import { PLAYBOOK_REGISTRY } from "@/lib/learn/playbookRegistry";
import PlaybookCard from "./PlaybookCard";

const PlaybookLibrary = () => {
  return (
    <div>
      <div className="mb-4 max-w-3xl">
        <h2 className="text-base font-semibold text-genie-text mb-1">Take-home playbooks</h2>
        <p className="text-xs sm:text-sm text-gray-600">
          Hand-crafted guides personalised with your Genie's name and brand colour — share with your team or save for later.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {PLAYBOOK_REGISTRY.map((playbook) => (
          <PlaybookCard key={playbook.slug} playbook={playbook} />
        ))}
      </div>
    </div>
  );
};

export default PlaybookLibrary;
